import React from 'react';
import { Tag } from 'antd';

const OptionTag = ({ options }) => {
	const optionsKeys = Object.keys(options);
	const optionsValues = Object.values(options);
	
	return (<div className='Options'>
		{optionsValues.map((item, i) => {
			return <Tag key={i} color='#108ee9'> {optionsKeys[i]} : {item}</Tag>;
		})}
	</div>);
};

export default OptionTag;


// WEBPACK FOOTER //
// ./src/components/OptionTag/OptionTag.js